'use strict'
module.exports = {
	NODE_ENV: '"demo"',

	// URLs
	APP_BASEURL: '"https://hermes-demo.protopia.co/"',
	API_BASEURL: '"https://api-demo.protopia.co/"',
	// Browser clients must use the public gateway, never the local build fallback.
	CORE_API_URL: '"https://agw-demo.protopia.co"',
	APP_REDIRECT_URL: '"https://protopia.co/maintenance"',

	// Auth0
	AUTH0_DOMAIN: '"protopia.auth0.com"',
	AUTH0_CLIENT: '"VgCqT7QaAeTvRHKaTh9XtoKmjAzmjb9Z"',
	AUTH0_CALLBACK: '"https://hermes-demo.protopia.co/callback"',

	// APIs
	NLP_API_KEY: '"AIzaSyAuG9BzAULL1S1BCYHCzOjUVraN7EVBXZQ"',

	// Branding
	LOGO_URL: '"https://storage.googleapis.com/protopia/logos/logo_protopia_xs.png"',

	// LinkedIn Integration
	LINKEDIN_CLIENT_ID: '"77lqp1d3zdrmee"',
	LINKEDIN_CLIENT_SECRET: '"80w213F5rvSTL9zM"',
	LINKEDIN_REDIRECT_URI: '"https://hermes-demo.protopia.co/thank-you"',
	LINKEDIN_STATE_KEY: '"PROTOPIA"',

	// App Settings
	DEFAULT_EMAIL: '"team@protopia.co"',
	RANDOM_INTEREST_COUNT: 15,
	ADDITIONAL_PARAM_FRIENDLY_COUNT: 12,
	APP_REDIRECT_TIME: 5000,
	CAPTCHA_SITEKEY: '6LeLKvsqAAAAAHaBUE-R4_iEwPxGgcz7aKcZrFZN',
	VUE_APP_PROCESS_DASHBOARD_URL: '"https://hermes-demo.protopia.co/process-dashboard"',

	// Core-api (recruiting endpoints only — public routes)
	CORE_API_URL: '"https://agw-demo.protopia.co"',

	// Public base of the recruiting wizard (see local.env.js for the pattern).
	RECRUITING_BASEURL: '"https://opportunities-demo.protopia.co"'
}



//////////////////
// WEBPACK FOOTER
// ./config/demo.env.js
// module id = iQi3
// module chunks = 1